export const environment = {
    production: false,
    adminApi: 'https://admin.beta.iclicker.com',
    trogonApi: 'https://api.beta.iclicker.com/trogon',
    gatewayApi: 'https://api.beta.iclicker.com',
    hostname: 'https://account.beta.iclicker.com',
    studentApp: "https://student.beta.iclicker.com",
    instructorApp: "https://instructor.beta.iclicker.com"
  };
  